<template>
  <div>
    <b-navbar toggleable="lg" type="dark" class="menu-header">
      <b-navbar-brand to="/" target="_blank">
        <img class="icon_logo" src="/static/images/sport.png" alt=""> ИС ЕКП
      </b-navbar-brand>

      <b-navbar-brand>
        <label style="font-size: 0.7em; color: white">
          Вы вошли как: <b><u>{{ userObj.username }}</u></b>
        </label>
      </b-navbar-brand>

      <b-navbar-toggle v-b-toggle.sidebar-backdrop target="nav-collapse">
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav toggleable="md" class="ml-auto">
          <div v-for="item in menu" :key="item.index" v-if="canShowMenuItem(item)">
            <b-nav-item v-if="!item.children" :to="item.url" :target="item.newBlanc ? '_blank' : ''">
              <!--              <b-icon :icon="item.icon"></b-icon>-->
              <b>{{ item.title }}</b>
            </b-nav-item>
            <b-nav-item-dropdown :text="item.title" right v-else class="myclass">
              <template #button-content>
                <!--                <b-icon :icon="item.icon"></b-icon>-->
                <b>{{ item.title }}</b>
              </template>
              <b-dropdown-item variant="light"
                               active-class="text-light"
                               v-for="child in item.children"
                               :key="child.index"
                               :to="child.url"
                               v-if="canShowMenuItem(child)">
                <b-icon :icon="child.icon"/>
                <b> {{ child.title }}</b>
              </b-dropdown-item>

            </b-nav-item-dropdown>
          </div>
          <b-nav-item to="/logout">
            <b-icon icon="box-arrow-right"></b-icon>
            <b>Выйти</b>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>

    </b-navbar>
    <b-sidebar
        id="sidebar-backdrop"
        title="ИС ЕКП"
        backdrop-variant="secondary"
        backdrop
        bg-variant="dark"
        text-variant="light"
        shadow
    >
      <b-container fluid>
        <div class="accordion" role="tablist">
          <b-card no-body class="mb-1" v-for="item in menu" :key="item.key" bg-variant="secondary">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="item.key" variant="info" :to="item.url" class="menuitem">
                <b-icon :icon="item.icon"></b-icon>
                <b>{{ item.title }}</b>
              </b-button>
            </b-card-header>
            <b-collapse :id="item.key" accordion="my-accordion" role="tabpanel" v-if="item.children">
              <b-list-group>
                <b-list-group-item variant="warning" class="text-dark text-center menuitem"
                                   v-for="child in item.children" :key="child.key" :to="child.url">
                  <b-icon :icon="child.icon"/>
                  <b>{{ child.title }}</b>
                </b-list-group-item>
              </b-list-group>
            </b-collapse>
          </b-card>
          <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
            <b-button block variant="danger" to="/logout">
              <b-icon icon="box-arrow-right"></b-icon>
              <b>Выйти</b>
            </b-button>
          </div>
        </div>
      </b-container>

      <!--<template #footer="{ hide }">-->
      <!--<div class="d-flex bg-dark text-light align-items-center px-3 py-2">-->
      <!--<b-button block variant="info" to="/logout">-->
      <!--<b-icon icon="box-arrow-right"></b-icon> <b>Выйти</b>-->
      <!--</b-button>-->
      <!--</div>-->
      <!--</template>-->

    </b-sidebar>
  </div>
</template>

<script>
import http from '@/http-common'
import authHeader from "@/services/auth-header";
import tokenService from "@/services/token.service";

export default {
  data() {
    return {
      collapsed: true,
      userObj: {username: '', org: '', roles: []},
      menu: [
        {
          title: 'На главную', icon: 'box', key: 'main', url: '/', newBlanc: true
        },
        {
          title: 'Справочники', icon: 'box', key: 'spr', children: [
            {title: 'Пользователи', url: '/ekp/userslist', icon: 'person-circle', isAdmin: true},
            {title: 'Роли', url: '/ekp/roles', icon: 'person-bounding-box', isAdmin: true},
            {title: 'Ответственные', url: '/ekp/people', icon: 'person-square', isAdmin: true},
            {title: 'Раздел ЕКП', url: '/ekp/sportkind', icon: 'tags'},
            {title: 'Спортивные федерации', url: '/ekp/federslist', icon: 'star'},
            {title: 'Объекты спорта', url: '/ekp/location', icon: 'building'},
            {title: 'Статус мероприятий', url: '/ekp/eventkind', icon: 'list-stars'},
            {title: 'Рабочий фильтр', url: '/ekp/eventstate', icon: 'filter'},
            {title: 'Организации', url: '/ekp/organization', icon: 'building', isAdmin: true},
            {title: 'Характеристики ЕКП', url: '/ekp/workkind', icon: 'card-checklist'},
            {title: 'Справочник званий', url: '/ekp/rank', icon: 'bookmark-star-fill'},
            {title: 'Справочник школ', url: '/ekp/school', icon: 'building'},
            {title: 'Справочники для Спортсменов', url: '/ekp/totalspr', icon: 'card-checklist'},
          ]
        },
        {
          title: 'ЕКП', icon: 'calendar3', key: 'ekp',
          children: [
            {title: 'Календарь', url: '/ekp/data', icon: 'calendar2-date'},
            {title: 'Лимиты', url: '/ekp/limit', icon: 'bar-chart-line'},
            {title: 'Заявки в ЕКП', url: '/ekp/requestEvent', icon: 'card-checklist'},
//                            {title: 'Заявки на участие', url: 'requestSport', icon: 'card-checklist'},
            {title: 'Спортсмены', url: '/ekp/peopleSport', icon: 'card-checklist'},
            {title: 'Документы', url: '/ekp/document', icon: 'calendar2-date'},
            {title: 'Перенос сумм', url: '/ekp/moveSumma', icon: 'arrow-left-right'},
          ]
        },
        {
          title: 'КОСГУ(Статьи)', icon: 'diagram3', key: 'cost',
          children: [
            {title: 'Статьи', url: '/ekp/analyticCode', icon: 'diagram2'},
            {title: 'Нормы расходов', url: '/ekp/norm', icon: 'bar-chart-line'}
          ]
        },
        {
          title: 'Отчеты', icon: 'layout-text-window', key: 'report',
          children: [
            {title: 'Сводный отчет', url: '/ekp/reportkind', icon: 'layout-text-window-reverse'},
            {title: 'Общий отчет ЕКП', url: '/ekp/reportekp', icon: 'layout-text-window-reverse'},
            {title: 'Итоговый отчет по расходам', url: '/ekp/reportcost', icon: 'layout-text-window-reverse'},
            {
              title: 'Отчет по количеству мероприятий и заявок',
              url: '/ekp/reportrequest',
              icon: 'layout-text-window-reverse'
            },
            {title: 'Журналирование', url: '/ekp/logging', icon: 'layout-text-window-reverse'}
          ]
        },
        {
          title: 'Настройки', icon: 'gear', key: 'sett', isAdmin: true,
          children: [
            {title: 'Смета', url: '/ekp/settingsmeta', icon: 'gear', isAdmin: true},
            {title: 'Цвет строк таблицы ЕКП', url: '/ekp/settingekp', icon: 'gear-wide', isAdmin: true}
          ]
        },
      ]
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      // let user = localStorage.getItem("user")
      // console.log("User: " + user)
      let vm = this
      // authHeader()
      http.get('/users/status')
      .then((response) => {
        vm.userObj = response.data
      })
      .catch((error) => {
            console.log(error.message)
            // Store.dispatch('logout')
          }
      )
    },
    canShowMenuItem(item) {
      // Если пункт не требует прав администратора, показываем всем
      if (!item.isAdmin) return true;
      // Если требует, проверяем наличие роли ADMIN
      return this.userObj.roles && this.userObj.roles.includes('ADMIN');
    }
  }
}
</script>

<style>
.menuitem {
  font-size: 0.8em;
}

.icon_logo {
  max-width: 20px;
  margin: 0 auto;
}

.myclass .dropdown-menu {
  margin-top: 15px;
  background: linear-gradient(0deg, rgba(42, 92, 141, 1) 0%, rgba(53, 54, 61, 1) 50%);
}

.myclass a:hover {
  background: #4c6c78; /* Цвет фона под ссылкой */
}

.myclass a:active {
  background: #4c6c78; /* Цвет фона под ссылкой */
}

.menu-header {
  border-bottom: 1px solid #e2e8f0;
  color: white;
  background: #2A5C8D;
  background: linear-gradient(90deg, rgba(42, 92, 141, 1) 0%, rgba(53, 54, 61, 1) 50%);
}

/*.dropdown-menu {*/
/*display: block;*/
/*transition: max-height 300ms ease-in-out;*/
/*max-height: 500px!important;*/
/*}*/
/*.navbar-nav .dropdown-menu {*/
/*max-height: 0;*/
/*overflow: hidden;*/
/*transition: max-height 0.5s;*/
/*}*/
/*.navbar-nav .dropdown-menu.show {*/
/*max-height: 500px;*/
/*}*/
</style>
